import React from "react";
import './Button_Common.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Common_Button({
  onClick,
  className,
  margin,
  text,
  border,
  background,
  borderRadius,
  fontSize,
  color,
  fontWeight,
  padding,
  icon,
  showHeart,
}) {
  const buttonStyle = {
    background,
    borderRadius,
    border,
    fontSize,
    fontWeight,
    color,
    padding,
    margin,
    className,
  };
  return (
    <>
      <button onClick={onClick} type="button" className={className} style={buttonStyle}>
      {text}
      {icon && (
        <FontAwesomeIcon
          icon={icon}
          className={`heart-icon me-2 ${showHeart ? "heart-icon  active" : ""}`}
        />
      )}
    
    </button>
    </>
  );
}

export default Common_Button;